<div class="commerce-container">
  <div class="card">
    <div class="menu">
      <div
        class="nav-button"
        [class.active]="selectedTab === 'integrations'"
        (click)="selectedTab = 'integrations'"
      >
        <p>Integraciones</p>
        <img src="/assets/icons/person.svg" alt="personal-data" />
      </div>
      <div
        class="nav-button"
        [class.active]="selectedTab === 'customization'"
        (click)="selectedTab = 'customization'"
      >
        <p>Personalización</p>
        <img src="/assets/icons/wallet.svg" alt="accounts" />
      </div>
      <div
        class="nav-button"
        [class.active]="selectedTab === 'monetization'"
        (click)="selectedTab = 'monetization'"
      >
        <p>Reglas automáticas</p>
        <img src="/assets/icons/commerce/automatic-rules.svg" alt="Reglas automáticas" />
      </div>
    </div>
    <div class="content" *ngIf="selectedTab === 'integrations'">
      <div class="control" *ngIf="selectedIntegration === ''">
        <p class="label">Cobrá en criptomonedas de forma fácil</p>
        <p class="text">
          Con Commerce podés añadir la posibilidad de cobrar a tus clientes con Criptomonedas de una
          forma rápida y sencilla. Comenzá ahora mismo con algunas las opciones que hemos preparado
          para vos.
        </p>
        <div class="actions">
          <div class="integration-button" (click)="selectedIntegration = 'magento'">
            <img src="assets/images/integrations/magento.svg" alt="magento" />
            <p>Magento</p>
          </div>
          <div class="integration-button" (click)="selectedIntegration = 'woo'">
            <img src="assets/images/integrations/woo.svg" alt="woocommerce" />
            <p>WooCommerce</p>
          </div>
          <div class="integration-button" (click)="selectedIntegration = 'vtex'">
            <img src="assets/icons/vtex.svg" alt="vtex" />
            <p>Vtex</p>
          </div>
          <div class="integration-button smaller-img" (click)="selectedIntegration = 'custom'">
            <img src="assets/images/integrations/custom1.svg" alt="custom" />
            <p>Personalizada</p>
          </div>
          <div class="integration-button smaller-img" (click)="selectedIntegration = 'qr'">
            <img src="assets/images/integrations/qr.svg" alt="qr" />
            <p>QR físico</p>
          </div>
        </div>
      </div>
      <div class="integration-config" *ngIf="selectedIntegration === 'magento'">
        <div class="title">
          <div class="back" (click)="goBack()">
            <img src="assets/icons/chevron-left-white.svg" alt="chevron-left" />
            <p class="label">Magento</p>
          </div>
        </div>
        <p class="text">
          Para integrar los pagos con Magento necesitarás ingresar estas credenciales en la
          configuración de tu tienda.
        </p>
        <div class="action-btn">
          <img src="assets/images/book.svg" alt="" />
          <p>Manual de integración</p>
          <a
            href="https://commerce.tiendacrypto.com/utilidades/integraciones/magento"
            target="_blank"
            rel="noopener noreferrer"
          ></a>
        </div>
        <app-credentials [credentials]="credentials"></app-credentials>
      </div>
      <div class="integration-config" *ngIf="selectedIntegration === 'woo'">
        <div class="title">
          <div class="back" (click)="goBack()">
            <img src="assets/icons/chevron-left-white.svg" alt="chevron-left" matRipple />
            <p class="label">WooCommerce</p>
          </div>
        </div>
        <p class="text">
          Para integrar los pagos con WooCommerce necesitarás instalar nuestro plugin y luego
          ingresar estas credenciales en la configuración.
        </p>
        <div class="action-btn">
          <img src="assets/images/book.svg" alt="" />
          <p>Manual de integración</p>
          <a
            href="https://commerce.tiendacrypto.com/utilidades/integraciones/woocommerce"
            target="_blank"
            rel="noopener noreferrer"
          ></a>
        </div>
        <app-credentials [credentials]="credentials"></app-credentials>
      </div>
      <div class="integration-config" *ngIf="selectedIntegration === 'vtex'">
        <div class="title">
          <div class="back" (click)="goBack()">
            <img src="assets/icons/chevron-left-white.svg" alt="chevron-left" matRipple />
            <p class="label">Vtex</p>
          </div>
        </div>
        <p class="text" *ngIf="credentials?.integrations?.vtex?.appKey">
          Para integrar los pagos con Vtex necesitarás instalar nuestro plugin y configurarlo como
          se muestra en el manual de integración.
        </p>
        <p class="text" *ngIf="!credentials?.integrations?.vtex?.appKey">
          Para poder integrar los pagos con Vtex por favor contacte al chat o mandá un mail a
          <b>info@tiendacrypto.com</b>.
        </p>
        <div class="action-btn" *ngIf="credentials?.integrations?.vtex?.appKey">
          <img src="assets/images/book.svg" alt="" />
          <p>Manual de integración</p>
          <a
            href="https://commerce.tiendacrypto.com/utilidades/integraciones/vtex"
            target="_blank"
            rel="noopener noreferrer"
          ></a>
        </div>
        <app-credentials [credentials]="credentials" [isVtex]="true"></app-credentials>
      </div>
      <div class="integration-config" *ngIf="selectedIntegration === 'custom'">
        <div class="title">
          <div class="back" (click)="goBack()">
            <img src="assets/icons/chevron-left-white.svg" alt="chevron-left" matRipple />
            <p class="label">Integración personalizada</p>
          </div>
        </div>
        <p class="text">
          Para hacer una integración personalizada necesitarás instalar nuestro plugin y luego
          ingresar estas credenciales en la configuración.
        </p>
        <div class="action-btn">
          <img src="assets/images/book.svg" alt="" />
          <p>Manual de integración</p>
          <a
            href="https://commerce.tiendacrypto.com/"
            target="_blank"
            rel="noopener noreferrer"
          ></a>
        </div>
        <app-credentials [credentials]="credentials"></app-credentials>
      </div>
      <app-qr-integration
        *ngIf="selectedIntegration === 'qr'"
        (goBackPressed)="goBack()"
      ></app-qr-integration>
    </div>
    <app-customization *ngIf="selectedTab === 'customization'"></app-customization>
    <div class="content-money" *ngIf="selectedTab === 'monetization'">
      <img src="/assets/icons/monetizacion.svg" alt="personal-data" />
      <div class="setting-description">
        <h3 class="title">Convertir automáticamente criptomonedas a pesos</h3>
        <p class="information">
          Los ingresos que recibas en criptomonedas serán convertidos automáticamente a pesos.
        </p>
      </div>
      <div class="contentBox">
        <mat-slide-toggle
          labelPosition="before"
          [ngClass]="criptoToPesos ? 'activated' : 'deactivated'"
          [checked]="criptoToPesos"
          [(ngModel)]="criptoToPesos"
          (change)="onChange('autoSellToArs')"
        >
          {{ criptoToPesos ? 'Activado' : 'Desactivado' }}
        </mat-slide-toggle>
      </div>
    </div>
  </div>
</div>
